module.exports = __webpack_public_path__ + "img/Nebenstelle_Verbindung.6cb6429f.svg";